import { Activity } from 'lucide-react';

/**
 * LoginBrandingPreview
 * Live mock of the login screen using the current branding values.
 * Rendered inside the Branding tab while the admin edits colors and uploads assets.
 */
export default function LoginBrandingPreview({
  institutionName,
  primaryColor,
  secondaryColor,
  accentColor,
  logoUrl,
  backgroundUrl,
  poweredByEnabled = true,
}) {
  const primary = primaryColor || '#0891b2';
  const secondary = secondaryColor || primary;
  const accent = accentColor || primary;

  return (
    <div className="rounded-xl border border-slate-200 overflow-hidden shadow-sm bg-white" data-testid="login-preview">
      <div className="px-3 py-2 border-b border-slate-100 bg-slate-50 flex items-center justify-between">
        <span className="text-[11px] font-medium text-slate-600">Vista previa del login</span>
        <span className="text-[10px] text-slate-400">actualiza en vivo</span>
      </div>
      <div
        className="relative h-72 w-full flex items-center justify-center"
        style={{
          backgroundImage: backgroundUrl
            ? `url(${backgroundUrl})`
            : `linear-gradient(135deg, ${primary} 0%, ${secondary} 100%)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {/* Overlay so the card is readable over any background */}
        {backgroundUrl && (
          <div className="absolute inset-0 bg-black/25" />
        )}
        {/* Login card mock */}
        <div className="relative bg-white rounded-lg shadow-xl w-64 p-4 space-y-3">
          <div className="flex items-center justify-center">
            {logoUrl ? (
              <img
                src={logoUrl}
                alt="Logo"
                className="max-h-10 object-contain"
                onError={(e) => { e.currentTarget.style.display = 'none'; }}
              />
            ) : (
              <div className="flex items-center gap-1.5">
                <div
                  className="w-7 h-7 rounded-md flex items-center justify-center"
                  style={{ backgroundColor: primary }}
                >
                  <Activity size={16} className="text-white" />
                </div>
                <span className="font-semibold text-slate-800 text-sm">SimuClinic</span>
              </div>
            )}
          </div>
          <div className="text-center">
            <div className="text-[11px] text-slate-500 leading-tight" title={institutionName}>
              {institutionName || 'Institución'}
            </div>
          </div>
          <div className="space-y-1.5">
            <div className="h-7 rounded border border-slate-200 bg-slate-50" />
            <div className="h-7 rounded border border-slate-200 bg-slate-50" />
          </div>
          <button
            type="button"
            className="w-full h-8 rounded text-white text-xs font-medium"
            style={{ backgroundColor: primary }}
          >
            Ingresar
          </button>
          <button
            type="button"
            className="w-full h-7 rounded text-xs font-medium border"
            style={{ borderColor: accent, color: accent }}
          >
            Crear cuenta
          </button>
          {poweredByEnabled && (
            <div className="text-center text-[9px] text-slate-400 pt-1">
              Powered by SimuClinic
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
